import { Injectable } from '@angular/core';
import {WidgetBaseComponent} from './widget-base/widget-base.component';

@Injectable({
  providedIn: 'root'
})
export class WidgetService {
  private widgetsMap = new Map<string, WidgetBaseComponent>();

  public addWidget(src: WidgetBaseComponent): void {
    if (this.widgetsMap.has(src.widgetName)) {
      const errorStr = 'Widget [' + src.widgetName + '] alreay defined !';
      console.error(errorStr);
      alert(errorStr);
      return;
    }
    this.widgetsMap.set(src.widgetName, src);
  }
}
